"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Provides functionality to manipulate and check a plain
 * javascript object that keeps a user session.
 * Maximum session lifetime until the application is reloaded.
 */
var SimpleStorage = function () {
    function SimpleStorage() {
        (0, _classCallCheck3.default)(this, SimpleStorage);

        this.sessionToken = null;
        this.refreshToken = null;
    }

    (0, _createClass3.default)(SimpleStorage, [{
        key: "getRefreshToken",
        value: function getRefreshToken() {
            return this.refreshToken;
        }
    }, {
        key: "saveRefreshToken",
        value: function saveRefreshToken(token) {
            this.refreshToken = token;
        }
    }, {
        key: "deleteRefreshToken",
        value: function deleteRefreshToken() {
            this.refreshToken = null;
        }
    }, {
        key: "getSessionToken",
        value: function getSessionToken() {
            return this.sessionToken;
        }
    }, {
        key: "saveSessionToken",
        value: function saveSessionToken(token) {
            this.sessionToken = token;
        }
    }, {
        key: "deleteSessionToken",
        value: function deleteSessionToken() {
            this.sessionToken = null;
        }
    }, {
        key: "isLoggedIn",
        value: function isLoggedIn() {
            return this.sessionToken !== null;
        }
    }]);
    return SimpleStorage;
}();

exports.default = SimpleStorage;
